import { SIZE_FULL } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';
import { TiktokWidget } from '@/components/pages/analyze/widget/TiktokWidget';

export const mostEngagingPostsConfig = {
    title: 'chart.tiktok.widget_most_engaging_videos',
    id: 'widget_most_engaging_posts',
    size: SIZE_FULL,
    sortFields: [
        'engagement_rate',
        'engagement_on_views',
        'created',
        'likes',
        'comments',
        'shares',
        'video_views'
    ],
    type: 'widget',
    element: TiktokWidget,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
